var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0.177582H10C4.47715 0.177582 0 4.6597 0 10.1887V25.2053C0 30.7343 4.47715 35.2164 10 35.2164H25C30.5228 35.2164 35 30.7343 35 25.2053V10.1887C35 4.6597 30.5228 0.177582 25 0.177582Z",
    fill: "#87CBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.5 23V12C8.5 8 9.5 7 13.5 7H20.5C24.5 7 25.5 8 25.5 12V22C25.5 22.14 25.5 22.28 25.49 22.42",
    stroke: "#87CBFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 20H25.5V23.5C25.5 25.43 23.93 27 22 27H12C10.07 27 8.5 25.43 8.5 23.5V22.85C8.5 21.28 9.78 20 11.35 20Z",
    stroke: "#87CBFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 12H21",
    stroke: "#87CBFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 15.5H18",
    stroke: "#87CBFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualsIcon);
export default __webpack_public_path__ + "static/media/manuals-icon.2ca1f246ef034a5e375a885fccb21d6f.svg";
export { ForwardRef as ReactComponent };